<template>
  <div>
    <el-form :model="form" inline>
      <el-table
        :data="form.contractCollectionPlanList"
        align="left"
        class="tablePage employeelist xzl-el-table-class"
        style="width: 100%"
      >
        <el-table-column width="220px" label="应收金额">
          <div slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.row.isEditing"
              type="number"
              placeholder="￥0.00"
              v-model.number="
                form.contractCollectionPlanList[scope.$index].receivableAmount
              "
            ></el-input>

            <span v-else>{{ scope.row.receivableAmount | separator }}</span>
          </div>
        </el-table-column>
        <el-table-column label="应收时间">
          <div slot-scope="scope">
            <el-date-picker
              v-if="scope.row.isEditing"
              v-model="
                form.contractCollectionPlanList[scope.$index].receivableTime
              "
              type="date"
              size="mini"
              value-format="yyyy-MM-dd"
              placeholder="请选择应收日期"
              clearable
              prefix-icon=" "
            ></el-date-picker>
            <span v-else>{{ scope.row.receivableTime }}</span>
          </div>
        </el-table-column>
        <el-table-column label=" "></el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.isEditing"
              @click="handleRowSaveOrEdit(scope.$index, 1)"
              type="text"
              size="small"
              >保存</el-button
            >
            <el-button
              v-else
              type="text"
              @click="handleRowSaveOrEdit(scope.$index, 2)"
              size="small"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="handleDeleteRow(scope.$index)"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="tableNoData">
            <div class="bgBox iconfont iconzanwu"></div>
            <div class="text">暂时没有数据呀～</div>
          </div>
        </template>
      </el-table>
      <div class="add-plat-btn" @click="handleAddPlan">添加计划</div>
    </el-form>
  </div>
</template>

<script>
import {
  saveContractCollectionPlan,
  removeContractCollectionPlan,
} from "@/api/ContractManagement";
export default {
  data() {
    return {
      form: {
        contractCollectionPlanList: [
          {
            contractId: null,
            receivableAmount: null,
            receivableTime: null,
            isEditing: true,
          },
        ],
      },
    };
  },
  props: ["contractCollectionPlanList", "contractId"],
  methods: {
    handleRowSaveOrEdit(index, type) {
      if (type === 1) {
        // 保存

        if (this.contractId) {
          this.saveContractCollectionPlan(
            this.form.contractCollectionPlanList[index]
          );
        } else {
          this.form.contractCollectionPlanList[index].isEditing = false;
          this.$emit("confirm", this.form.contractCollectionPlanList);
        }
      } else if (type === 2) {
        // 编辑
        this.form.contractCollectionPlanList[index].isEditing = true;
      }
    },
    async saveContractCollectionPlan(val) {
      let params = { ...val };
      params.contractId = this.contractId;
      params.updatePlan = 1;
      params.receivableAmount = params.receivableAmount * 1;
      const res = await saveContractCollectionPlan(params);
      if (res.code === 200) {
        let message = "添加成功";
        if (params.id) {
          message = "编辑成功";
        }
        this.$message.success(message);
        val.id = res.data;
        val.isEditing = false;
      }
    },
    handleDeleteRow(index) {
      if (this.contractId) {
        this.removeContractCollectionPlan(index);
      } else {
        this.form.contractCollectionPlanList.splice(index, 1);
        this.$emit("confirm", this.form.contractCollectionPlanList);
      }
    },
    async removeContractCollectionPlan(index) {
      const res = await removeContractCollectionPlan({idList:[this.form.contractCollectionPlanList[index].id]});
      if (res.code === 200) {
        this.$message.success("删除成功");
        this.form.contractCollectionPlanList.splice(index, 1);
      }
    },
    handleAddPlan() {
      this.form.contractCollectionPlanList.push({
        contractId: null,
        receivableAmount: null,
        receivableTime: "",
        isEditing: true,
      });
    },
  },
  watch: {
    contractCollectionPlanList: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.form.contractCollectionPlanList = newVal;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.add-plat-btn {
  height: 32px;
  text-align: center;
  line-height: 32px;
  color: #ccc;
  border: 1px dashed #ccc;
  margin-top: 16px;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    color: #5b8cff;
    border-color: #5b8cff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/ContractManagement/components/PaymentPlan.vue